export default __webpack_public_path__ + "static/media/ic_buy_glp.8eb00e6a.svg";